import { render, staticRenderFns } from "./ShopWaiting.vue?vue&type=template&id=418919c0&scoped=true"
import script from "./ShopWaiting.vue?vue&type=script&lang=js"
export * from "./ShopWaiting.vue?vue&type=script&lang=js"
import style0 from "./ShopWaiting.vue?vue&type=style&index=0&id=418919c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418919c0",
  null
  
)

export default component.exports